import { render, staticRenderFns } from "./ReportSalesTarjeta.vue?vue&type=template&id=2804d2ae&scoped=true&"
import script from "./ReportSalesTarjeta.vue?vue&type=script&lang=js&"
export * from "./ReportSalesTarjeta.vue?vue&type=script&lang=js&"
import style0 from "./ReportSalesTarjeta.vue?vue&type=style&index=0&id=2804d2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2804d2ae",
  null
  
)

export default component.exports